import { observer }                    from 'mobx-react';
import { getStandDocumentStatusColor } from 'constants/StandDocumentStatuses';
import { getStandDocumentStatusLabel } from 'constants/StandDocumentStatuses';
import StandDocumentStatusModel        from 'models/StandDocumentStatusModel';
import StandModel                      from 'models/StandModel';
import { ApiCollection }               from 'collections/ApiCollection';

const StandDocumentStatus = observer(({stand, standDocumentStatusCollection}: {
    stand: StandModel,
    standDocumentStatusCollection: ApiCollection<StandDocumentStatusModel>
}) => {
  const standDocumentStatus = standDocumentStatusCollection.find(
    sds => sds.id === stand.standDocumentStatusId,
  );

  if (!standDocumentStatus) {
    return null;
  }

  return (
    <div style={{ display: 'flex' }}>
      <div
        style={{
          backgroundColor: getStandDocumentStatusColor(standDocumentStatus.reference),
          borderRadius: 7.5,
          height: 15,
          margin: '0px 5px 0px 0px',
          position: 'relative',
          top: 3,
          width: 15,
        }}
      />
      {getStandDocumentStatusLabel(standDocumentStatus.reference)}
    </div>
  );
});

export default StandDocumentStatus;
